// extracted by mini-css-extract-plugin
module.exports = {"cta":"Cta_cta__3EKVt","btn-promo":"Cta_btn-promo__1-0FO"};